import { render, staticRenderFns } from "./ClientUserForm.vue?vue&type=template&id=22cd45dc"
import script from "./ClientUserForm.vue?vue&type=script&lang=js"
export * from "./ClientUserForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperItems } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperItems})
